import { render, staticRenderFns } from "./NotEligibleDialog.vue?vue&type=template&id=225edf08"
import script from "./NotEligibleDialog.vue?vue&type=script&lang=ts"
export * from "./NotEligibleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports